"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAuthenticator = void 0;
const core_1 = require("../../core");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class BaseAuthenticator {
    constructor(session) {
        this.login = (loginData) => __awaiter(this, void 0, void 0, function* () {
            this.session.finishSession();
            const loginInfo = yield this.doLogin(loginData);
            this.session.initSession(loginInfo);
            return Promise.resolve(loginInfo);
        });
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.doLogout();
            }
            catch (e) {
                core_1.Log.warn('Logout failed', e);
            }
            finally {
                this.session.finishSession();
            }
        });
        this.session = session;
    }
    getSession() {
        return this.session;
    }
}
exports.BaseAuthenticator = BaseAuthenticator;
//# sourceMappingURL=index.js.map